import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { and, isArchivedFilter, or } from '../data'

interface PIICategoryTypeParametersList {
  CID?: number
  CategoryContext: string
  CategoryParamName: string
  ParamAllowedDataTypes: string
  ParamEnable: string
  ParamMode: number
  Severity: string
  Title: string
  eKey?: string
  eTag?: string
}
interface PIICategoryTypeParametersListMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
  paramAllowedFilter?: ''
  paramModeFilter?: 2 | 3
}

const LIST_NAME = 'PIICategoryTypeParametersList'
const COLUMN_NAMES = {
  CID: 'CID',
  CategoryContext: 'CategoryContext',
  CategoryParamName: 'CategoryParamName',
  ParamAllowedDataTypes: 'ParamAllowedDataTypes',
  ParamEnable: 'ParamEnable',
  ParamMode: 'ParamMode',
  Severity: 'Severity',
  Title: 'Title',
  eKey: 'eKey',
  eTag: 'eTag',
}
const addOrUpdatePIICategoryTypeParam = async (item) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const result = await list.addOrUpdateItem(item)
    return result
  } catch (error) {
    console.error(
      'An error occurred while adding or updating the inquiry:',
      error
    )
    throw new Error('Failed to add or update inquiry')
  }
}
const getPIICategoryTypeParametersListMetadata = async (
  args: PIICategoryTypeParametersListMetadataArgs
): Promise<PIICategoryTypeParametersList[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.Title

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.eKey,
      COLUMN_NAMES.eTag,
      COLUMN_NAMES.Title,
      COLUMN_NAMES.CategoryParamName,
      COLUMN_NAMES.CategoryContext,
      COLUMN_NAMES.ParamMode,
      COLUMN_NAMES.ParamEnable,
      COLUMN_NAMES.ParamAllowedDataTypes,
      COLUMN_NAMES.Severity,
      COLUMN_NAMES.CID
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PIICategoryTypeParametersList[]
}
const constructInquiryFilter = (
  args: PIICategoryTypeParametersListMetadataArgs
): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchivedFilter ?? null))

  // if (args.paramAllowedFilter) {
  //   filters.push(`ParamAllowedDataTypes eq '${args.paramAllowedFilter}'`)
  // }
  if (args.paramModeFilter) {
    filters.push(`ParamMode eq ${args.paramModeFilter}`)
  }
  const filter = and(...filters)
  return filter
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type PIICategoryTypeParametersList,
  type PIICategoryTypeParametersListMetadataArgs,
  addOrUpdatePIICategoryTypeParam,
  getPIICategoryTypeParametersListMetadata,
}
